export default __webpack_public_path__ + "static/media/Ellipse.8883810e.svg";